import { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';

import { NetworkErrors } from 'context';
import { appState, authState } from 'core/state';

import { isCareerViewer } from './isCareerViewer';

/**
 * Ролевой гард карьерного раздела (ТЗ 0069).
 *
 * 🔴 Это ПЕРВЫЙ из четырёх слоёв защиты, и единственный, который остаётся
 * четырёхсотчетвёртым. Роль — не то же, что членство: преподавателю и
 * демо-пользователю раздел не показывают вовсе, и сервер отбивает их токен по
 * всем карьерным полям. Продавать им тут нечего, объяснять нечего — 404.
 *
 * Членство теперь НЕ выбрасывает со страницы: оно приходит из
 * `myCareerJourney.locked[]` и рисуется объяснением с одним CTA. Раньше оба
 * слоя были свалены в `useCareerAccessGuard`, и не-участник получал 404 на
 * продающем экране.
 *
 * Хук вызывается ОДИН раз — в `CareerLayout`. До этого тот же `useEffect`
 * стоял четырьмя копиями (Growth, GrowthSectionLayout, GrowthMedals, Resume),
 * и пятый экран означал пятый шанс забыть одну.
 */
export const useCareerRoleGuard = (): void => {
  const { active_role, isDemoUser } = useReactiveVar(authState);
  const currentState = appState();

  useEffect(() => {
    if (!isCareerViewer(active_role) || isDemoUser) {
      appState({ ...currentState, networkError: NetworkErrors.pageIsNotAvailable });
    }
  }, [active_role, isDemoUser, currentState]);
};
